module.exports = __webpack_public_path__ + "static/img/3_Omnidataware_officialaccount.f5cff4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcodes/3_Omnidataware_officialaccount.jpg
// module id = ekCp
// module chunks = 1